import React from 'react';
import './NotificationsList.css';
import NotificationItem from './NotificationItem';

/**
 * Компонент для отображения списка уведомлений пользователя
 * @param {Array} notifications - Массив уведомлений
 * @param {function} onMarkAsRead - Функция для отметки уведомления как прочитанного
 * @param {function} onShowInvitePath - Функция для показа пути приглашений
 * @param {function} onDeleteNotification - Функция для удаления уведомления
 * @param {function} onReplyToNotification - Функция для ответа на уведомление
 * @param {boolean} isLoading - Флаг загрузки
 * @param {string} error - Текст ошибки (если есть)
 * @param {function} onRefresh - Функция для обновления списка уведомлений
 */
const NotificationsList = ({
  notifications,
  onMarkAsRead,
  onShowInvitePath,
  onDeleteNotification,
  onReplyToNotification,
  isLoading,
  error,
  onRefresh
}) => {
  return (
    <div className="screen-content">
      <h1>Сообщения</h1>
      
      {isLoading && (
        <div className="card" style={{ padding: '20px', textAlign: 'center' }}>
          <p>Загрузка уведомлений...</p>
        </div>
      )}

      {error && (
        <div className="card" style={{ padding: '20px', backgroundColor: 'rgba(255, 107, 107, 0.1)' }}>
          <p style={{ color: '#ff4545' }}>{error}</p>
          <button className="button button-primary" onClick={onRefresh}>
            Попробовать снова
          </button>
        </div>
      )}

      {!isLoading && !error && (!notifications || notifications.length === 0) && (
        <div className="card" style={{ padding: '30px 20px', textAlign: 'center' }}>
          <p>У вас нет уведомлений</p>
          <p className="subtle-text" style={{ marginTop: '10px' }}>
            Когда другие пользователи отправят вам сообщение, оно появится здесь.
          </p>
          <button className="button button-secondary" onClick={onRefresh}>
            Обновить
          </button>
        </div>
      )}

      {!isLoading && !error && notifications && notifications.length > 0 && (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
            <p className="subtle-text">Всего: {notifications.length}</p>
            <button className="button button-secondary" onClick={onRefresh}>
              Обновить
            </button>
          </div>
          
          <div className="notifications-container">
            {notifications.map((notification) => (
              <NotificationItem
                key={notification.id}
                notification={notification}
                onMarkAsRead={onMarkAsRead}
                onShowInvitePath={onShowInvitePath}
                onDeleteNotification={onDeleteNotification}
                onReplyToNotification={onReplyToNotification}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default NotificationsList; 